import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import useFileUpload from '../../../Hooks/useFileUpload';
import M_TRA_SIGN from './M_TRA_SIGN';
import { SaveLogicTraCustom02SessionSign1 } from './M_TRA_SIGN_Logic';

export default function M_TRA_SIGNF() {
  const { sessionCd } = useParams();
  const dispatch = useDispatch();
  const { navigate } = useAppNavigate();
  const { userInfo } = useSelector((s) => s.BaseInfo);
  const signatureCanvas = useRef(null);
  const [signInputs, setSignInputs] = useState({ mapUrl: '', mapFiles: {} });
  const [submitting, setSubmitting] = useState(false);
  const signUpload = useFileUpload({
    oldFilePathField: 'signImagePath',
    newFileNameField: 'saveName',
    getTargetPath: (_item, custCd) =>
      `Education/${custCd || 'default'}/TRA_CUSTOM_02`,
  });

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('안전보건교육 참석 서명'));
    dispatch(NavBarInfoActions.setBgColor('#FFF'));
  }, [dispatch]);

  const HandleClearSign = () => {
    signatureCanvas.current?.clear?.();
    signUpload.clearFiles();
    setSignInputs({ mapUrl: '', mapFiles: {} });
  };

  const HandleConfirmSign = async () => {
    if (submitting) return;
    const isEmpty = signatureCanvas.current?.isEmpty?.();
    if (isEmpty || !signInputs.mapUrl) {
      dispatch(
        showSnackbar({
          message: '서명을 먼저 입력해 주세요.',
          type: 'warning',
        })
      );
      return;
    }

    const signPath = await signUpload.SaveLogicFile();
    if (!signPath) {
      dispatch(
        showSnackbar({
          message: '서명 파일 경로를 생성하지 못했습니다.',
          type: 'error',
        })
      );
      return;
    }

    const payload = {
      sessionId: String(sessionCd ?? '').trim(),
      userNm: String(userInfo?.userNm ?? '').trim(),
      jobType: String(userInfo?.posiNm ?? '').trim(),
      tpaUserId: String(userInfo?.decUserId ?? '').trim(),
      remark: String(signPath),
    };

    if (!payload.sessionId || !payload.userNm) {
      dispatch(
        showSnackbar({
          message: '세션 또는 사용자 정보가 없습니다.',
          type: 'error',
        })
      );
      return;
    }

    console.log('[TRA_SIGN][SaveTraCustom02U3 payload]', payload);
    setSubmitting(true);
    try {
      const res = await SaveLogicTraCustom02SessionSign1(payload);
      const ok = res?.isSuccess === true || res?.IsSuccess === true;
      const msg = res?.message ?? res?.Message ?? '';
      if (!ok) {
        dispatch(
          showSnackbar({
            message: msg || '서명 저장에 실패했습니다.',
            type: 'error',
          })
        );
        return;
      }

      dispatch(
        showSnackbar({
          message: msg || '서명이 저장되었습니다.',
          type: 'success',
        })
      );
      signUpload.clearFiles();
      navigate('/Home');
    } catch (e) {
      const data = e?.response?.data;
      const m =
        typeof data === 'string'
          ? data
          : (data?.message ?? data?.Message ?? e?.message);
      dispatch(
        showSnackbar({
          message: m || '서명 저장 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      setSubmitting(false);
    }
  };

  const signUserId = String(
    userInfo?.decUserId ?? userInfo?.userid ?? ''
  ).trim();

  return (
    <M_TRA_SIGN
      sessionCd={sessionCd}
      signUserId={signUserId}
      signatureCanvas={signatureCanvas}
      signInputs={signInputs}
      setSignInputs={setSignInputs}
      signUpload={signUpload}
      onConfirm={HandleConfirmSign}
      onClear={HandleClearSign}
      confirmDisabled={submitting}
    />
  );
}
